import { BehaviorSubject } from 'rxjs';


const currentUserSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('currentUser')));

export const authenticationService = {
    login,
    logout,
    authVerify,
    currentUser: currentUserSubject.asObservable(),
    get currentUserValue() { return currentUserSubject.value }
};

function login(username, password, keepMeLogged, logIP, latIP, lngIP) {
    const requestOptions = {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
            username: username,
            password: password,
            keepMeLogged: keepMeLogged,
            logIP: logIP, latIP: "" + latIP, lngIP: "" + lngIP
        })
    };
    return fetch(`/api/Authentication/authenticate`, requestOptions)
        .then(response => response.json())
        .then(user => {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            if (user.id != null) {
                localStorage.setItem('currentUser', JSON.stringify(user));
                currentUserSubject.next(user);   
            }
            return user;
        });
}

function logout() {
    // remove user from local storage to log user out
    return fetch(`/api/Account/Logout`, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
        .then(response => response.json()).then(res => {
            if (res.successState) {
                //localStorage.setItem("lamcouser", JSON.stringify(res));
                //currentUserSubject.next(res);
                //gotoSuccessLogin(res.redirect);
            }
            localStorage.removeItem('currentUser');
            currentUserSubject.next(null);
            return res.successState;
        });    
}
function authVerify() {
    return fetch(`/api/Authentication/CheckAuthentication`, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
        .then(response => response.json()).then(res => {
            if (!res.status) {
                localStorage.removeItem('currentUser');
                currentUserSubject.next(null);
            }
            return res.status;
        });
    //const user = JSON.parse(localStorage.getItem("currentUser"));
    //if (user) {
    //    const decodedJwt = parseJwt(user.refreshToken);
    //    if (decodedJwt.expires * 1000 < Date.now()) {
    //        logout();
    //    }
    //}
}